// removed by extract-text-webpack-plugin
module.exports = {"eligibilityWidgetContainer":"eligibilityWidgetContainer__1DLtV","eligibilityWidgetInnerContainer":"eligibilityWidgetInnerContainer__QDye0","eligibilityWidgetBG1":"eligibilityWidgetBG1__1Kch-","eligibilityWidgetBG2":"eligibilityWidgetBG2__2psHi","eligibilityWidgetInputs":"eligibilityWidgetInputs__1BD8T","activateAndShop":"activateAndShop__184uR","otpText":"otpText__3rjX4","ActivationinputContainer":"ActivationinputContainer__Hgzt_","inputBox":"inputBox__2yf5m","submitButton":"submitButton__1-v7E","mobileNoPrefixCampaign":"mobileNoPrefixCampaign__2WZu8"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVB/activationInput/style.css
// module id = jHJI
// module chunks = 446